import { useDispatch, useSelector } from "react-redux"
import BannerHeader from "../../../Components/BannerHeader/BannerHeader"
import CustomerReview from "../../Body/CustomerReview/CutomerReview"
import Gallery from "../../Body/Gallery/Gallery"
import Footer from "../../Footer/Footer"
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav"
import { ContactUs } from "../Components/ContactUs/ContactUs"
import ServiceVideo from "../Components/ServiceVideo/ServiceVideo"
import FAQ from "../FAQ/FAQ"
import AboutForPublishers from "./AboutForPublishers/AboutForPublishers"
import classes from "./ForPublishers.module.css"
import { useEffect } from "react"
import { getAllFaq } from "../../../Store/actions/FaqAction"
import { urls } from "../../../Routes/Urls"
import useScrollToTop from "../../../Hooks/useScrollToTop";
import useScreenSize from "../../../Hooks/UseScreenSize"
import SEO from "../../../Components/SEO"
const bgImage = "Assets/Images/ServicePages/ForPublishers.png"

const ForPublishers = () => {
    const dispatch = useDispatch()
    const crumbs = [
        { title: "Home", path: ("/") },
        { title: "For Publishers", path: urls.FORPUBLISHERS },
    ]
    const video = useSelector((state) => state.serviceVideo?.videos?.forPublishersVideo)
    const allFaq = useSelector(state => state.Faq.questions);

    const {isSmallScreen} = useScreenSize()

    useEffect(() => {
        getAllFaq("category","For Publishers","",dispatch)
    },[])
    const scrollRef = useScrollToTop();

    return (
        <div ref={scrollRef}>
            <SEO
                canonicalUrl="https://www.rarebiblio.com/luxury-bookbinding-services-for-publishers"
                keywords={"Luxury Bookbinding Services for Publishers"}
                title={"Luxury Bookbinding Services for Publishers | Rare Biblio"}
                description={"Enhance your publications with Rare Biblio's luxury bookbinding services. Collaborate with us to offer authors personalized, high-quality editions they'll love."}
                structuredData={{
                    "@context": "https://schema.org",
                    "@graph": [
                      {
                        "@type": "Organization",
                        "name": "Rare Biblio",
                        "alternateName": "Luxury Bookbinding Services for Publishers",
                        "url": "https://www.rarebiblio.com/luxury-bookbinding-services-for-publishers",
                        "logo": "https://www.rarebiblio.com/Assets/Icons/logo.jpg",
                        "sameAs": [
                          "https://rarebiblio.com/",
                          "https://www.facebook.com/rarebiblio/",
                          "https://x.com/Rarebiblio",
                          "https://www.instagram.com/Rarebiblio",
                          "https://www.linkedin.com/company/Rarebiblio",
                          "https://www.pinterest.com/rare_biblio/"
                        ]
                      },
                      {
                        "@type": "FAQPage",
                        "mainEntity": [
                          {
                            "@type": "Question",
                            "name": "What are the benefits of partnering with Rare Biblio?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "Partnering with us allows publishers to offer premium leather-bound editions, increasing revenue and royalties, while elevating the prestige of both authors and books. Limited-edition books create higher demand and offer exclusive, collectible options for readers."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "Do we have access to dedicated support during the process?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "Yes, publishers receive dedicated assistance through a dedicated account manager. This ensures a smooth and seamless experience, helping with any inquiries, providing updates, and speeding up the process from start to finish."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "Is there a minimum order requirement for publishers?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "No, we offer flexible volume options. Whether you need a single special edition or a bulk order of customized volumes, we cater to your specific needs without pressure from large minimum orders."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "What types of books can be made into limited leather-bound versions?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "We can create limited leather-bound versions for a wide range of genres, including fiction, non-fiction, memoirs, and poetry. Whether it’s a novel, a collection of short stories, or a specialized academic text, we can craft a beautiful, customized edition that suits your book’s theme and audience."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "Can we include custom branding on the leather-bound editions for our publishing house?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "Absolutely! We can incorporate custom branding elements such as your logo, publisher’s name, or specific artwork on the leather-bound covers. This adds a personalized touch and helps reinforce your brand identity."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "How long does it take to receive a bulk order of custom leather-bound books?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "The production time depends on the specifics of your order, such as customization and order volume. Typically, it takes 2-4 weeks to complete an order, but we provide a timeline estimate based on your needs and keep you updated throughout the process."
                            }
                          },
                          {
                            "@type": "Question",
                            "name": "What is the process for getting started with a collaboration?",
                            "acceptedAnswer": {
                              "@type": "Answer",
                              "text": "To get started, simply reach out to us with your project details. You can contact us directly through our Contact Us form on the website or by emailing us at info@rarebiblio.com. Our team of experts will get in touch with you promptly to discuss your requirements, provide guidance, and walk you through the next steps for a seamless collaboration. We’ll work with you to ensure that every detail meets your expectations, from design to production."
                            }
                          }
                        ]
                      }
                    ]
                  }}
            />
            <PrimaryNav />
            <BannerHeader 
            bgImage={bgImage}
            crumbs={crumbs} title={"Luxury Bookbinding Services For Publishers"} desc={"Unite with us in a shared commitment to excellence"} />

            <ServiceVideo
                title={"Let’s Start Publishing Together"}
                videoSrc={video}
                desc={isSmallScreen ? "Our objective is to establish a long-lasting and reliable partnership with publishers so that they may provide their elite writers with the exclusive option of getting their writings turned into luxurious leather-bound editions." :
                    "We provide publishing houses with a special collaboration option that grants them access to our excellent bookbinding services. Our objective is to establish a long-lasting and reliable partnership with publishers so that they may provide their elite writers with the exclusive option of getting their writings turned into luxurious and premium masterpieces."
                }
            />

            <AboutForPublishers />
            <div className={classes.join}>
                <h2>
                    Join Hands With Us
                </h2>
                <p>
                Find out how Rare Biblo's superior bookbinding services might improve your publishing offers.<br/> <br/> Come celebrate the craft of bookmaking with us as we provide your writers and authors with premium quality leather-bound handcrafted customized books that are exceptional in terms of elegance and quality.
                Would you like a partnership with us? <br/> <br/> To get in touch with us and find out more about how we may collaborate, click the link below.

                </p>
            </div>

            <div className={classes.contactUs}>
                <ContactUs category={"forPublishers"} title={"Transform Your Publications—Contact Us Today"} />   
            </div>

            <Gallery />

            <CustomerReview />

            <FAQ data={allFaq} />
           

            <Footer />
        </div>
    )
}

export default ForPublishers